import { VITE_API_V2_URL } from "codes";
import { browserVersion, deviceDetect, isSafari } from "react-device-detect";
import { subscribeUser } from "serviceWorkerRegistration";

export const getDeviceID = () => {
  const navigator_info = window.navigator;
  const device = deviceDetect(navigator_info.userAgent);
  const uid = `${device.osName}-${device.osVersion}-${device.browserName}-${device.browserVersion}-${device.deviceType}`;
  return uid.toString();
};
const env = import.meta.env.VITE_ENV;
const debug = Boolean(env === "local" || env === "dev");

const isPushSupported = () =>
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  !(isSafari && browserVersion === "15.6");

export const triggerSubscription = async (contact_id: string) => {
  try {
    // Check push capabilities before requesting permission.
    if (isPushSupported() && "Notification" in window) {
      const permissionStatus = await Notification.requestPermission();
      if (permissionStatus === "granted") {
        await subscribeUser(contact_id);
        return true;
      }
      return false;
    }
    return false;
  } catch {
    if (debug)
      // eslint-disable-next-line no-console
      console.error("Error requesting notification permission.");
    return false;
  }
};

// Check if user is already subscribed to push notifications
export async function checkSubscription() {
  if (!isPushSupported()) return false;
  try {
    // eslint-disable-next-line compat/compat
    const registration = await navigator.serviceWorker.ready;
    if (!registration?.pushManager) return false;

    const subscription = await registration.pushManager.getSubscription();
    const rawToken = localStorage.getItem("token");
    if (!rawToken) return false;

    let token: { value?: string } | null;
    try {
      token = JSON.parse(rawToken);
    } catch {
      return false;
    }

    if (subscription) {
      const response = await fetch(
        `${VITE_API_V2_URL}/notifications/check-subscription`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token?.value}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            endpoint: subscription.endpoint,
          }),
        }
      );
      const data = await response.json();
      return data.exists;
    }
    return false;
  } catch {
    if (debug)
      // eslint-disable-next-line no-console
      console.error("Error checking push subscription.");
    return false;
  }
}

export const unsubscribeUser = async () => {
  if (!isPushSupported()) return false;
  try {
    // eslint-disable-next-line compat/compat
    const registration = await navigator.serviceWorker.ready;
    if (!registration?.pushManager) return false;

    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();
      return true;
    }
    return false;
  } catch {
    if (debug)
      // eslint-disable-next-line no-console
      console.error("Error unsubscribing user.");
    return false;
  }
};
